module.exports = __webpack_public_path__ + "35438332cfdee4c337df6ab19659a7c1.woff";